import dayjs from 'dayjs'
import { isUndefined } from 'lodash'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useProfileStore } from '../store/storeProfile'
import { useWrapperStore } from '../store/storeWrapper'
import { useCountdownTimer } from './useCountdownTimer'

type PersonalDiscountState = {
    hasDiscount: boolean
    discountPercent: number
    discountEndDate: string | null
}

export const usePersonalDiscount = () => {
    const { balance, tariffList } = useProfileStore((state) => state)
    const { isTempUser, setOpenDiscountDialog } = useWrapperStore((state) => state)

    const [personalDiscount, setPersonalDiscount] = useState<PersonalDiscountState>({
        hasDiscount: false,
        discountPercent: 0,
        discountEndDate: null,
    })

    useEffect(() => {
        if (isTempUser) {
            setPersonalDiscount({
                hasDiscount: false,
                discountPercent: 0,
                discountEndDate: null,
            })
        } else {
            if (tariffList) {
                const discountTariff = tariffList?.find(
                    (tariff) =>
                        tariff.discount_end_datetime &&
                        dayjs(tariff.discount_end_datetime).isAfter(new Date()),
                )

                const discountPercent = discountTariff?.discount_amount

                setPersonalDiscount({
                    hasDiscount: !!discountPercent && discountPercent > 0,
                    discountPercent: discountPercent ?? 0,
                    discountEndDate: discountTariff?.discount_end_datetime ?? null,
                })
            }
        }
    }, [tariffList, isTempUser])

    const timer = useCountdownTimer(personalDiscount.discountEndDate)

    const promotePersonalDiscount = useCallback(() => {
        setOpenDiscountDialog(
            personalDiscount.hasDiscount &&
                !timer.isComplete &&
                !isUndefined(balance) &&
                balance <= 0,
        )
    }, [balance, timer.isComplete, personalDiscount])

    return useMemo(
        () => ({
            ...personalDiscount,
            promotePersonalDiscount,
            timer,
        }),
        [promotePersonalDiscount, timer, personalDiscount],
    )
}
